export const USER_FEEDBACK_DATA_TYPES = [
  "NUMERIC",
  "CATEGORICAL",
  "BOOLEAN",
] as const;
export type UserFeedbackDataType = (typeof USER_FEEDBACK_DATA_TYPES)[number];

export const USER_FEEDBACK_SOURCES = ["USER", "EVAL", "SYSTEM"] as const;
export type UserFeedbackSource = (typeof USER_FEEDBACK_SOURCES)[number];

export const NAMI_CHAT_THUMBS = {
  subjectType: "nami_chat_message",
  scoreName: "thumbs",
} as const;

export const USER_FEEDBACK_SUBJECT_TYPES = [
  NAMI_CHAT_THUMBS.subjectType,
] as const;
export type UserFeedbackSubjectType =
  (typeof USER_FEEDBACK_SUBJECT_TYPES)[number];

export interface UserFeedbackConfigDef {
  subjectType: UserFeedbackSubjectType;
  scoreName: string;
  label: string;
  description: string | null;
  dataType: UserFeedbackDataType;
  numericMin: number | null;
  numericMax: number | null;
  numericStep: number | null;
  categoricalOptions: Array<{ value: string; label: string }> | null;
  commentEnabled: boolean;
  commentRequired: boolean;
  sortOrder: number;
}

export const USER_FEEDBACK_CONFIGS: readonly UserFeedbackConfigDef[] = [
  {
    subjectType: NAMI_CHAT_THUMBS.subjectType,
    scoreName: NAMI_CHAT_THUMBS.scoreName,
    label: "Was Nami's response helpful?",
    description: null,
    dataType: "BOOLEAN",
    numericMin: null,
    numericMax: null,
    numericStep: null,
    categoricalOptions: null,
    commentEnabled: true,
    commentRequired: false,
    sortOrder: 0,
  },
];

export function findFeedbackConfig(
  subjectType: UserFeedbackSubjectType,
  scoreName: string,
): UserFeedbackConfigDef | undefined {
  return USER_FEEDBACK_CONFIGS.find(
    (c) => c.subjectType === subjectType && c.scoreName === scoreName,
  );
}

export function listFeedbackConfigs(
  subjectType: UserFeedbackSubjectType,
): UserFeedbackConfigDef[] {
  return USER_FEEDBACK_CONFIGS.filter(
    (c) => c.subjectType === subjectType,
  ).sort((a, b) => a.sortOrder - b.sortOrder);
}
